// /* eslint-disable */
import Cookies from "js-cookie";
import focusTrap from "focus-trap";

const COOKIE_CLOSE = "__mardens-popup-closed";
const COOKIE_FIRST = "__mardens-popup-first-visit";
const COOKIE_SECOND = "__mardens-popup-second-visit";
const COOKIE_SUBMISSION = "__mardens-popup-submission";

let trap;

function init() {
  let $popupWrap = $(".pop-up--wrap");
  let $popup = $(".pop-up");
  let $toggle = $(".pop-up-toggle");
  let popupFormID = document.getElementById("pop-form-id").innerHTML;

  window.addEventListener("beforeunload", function() {
    if (Cookies.get(COOKIE_SECOND) != 1 && Cookies.get(COOKIE_FIRST) == 1) {
      Cookies.set(COOKIE_SECOND, 1);
    }
  });

  if (!$popup.length) {
    return;
  }

  if (Cookies.get(COOKIE_SUBMISSION) != 1) {
    //if this is the first page visit of the session
    if (Cookies.get(COOKIE_CLOSE) != 1 && Cookies.get(COOKIE_SECOND) != 1) {
      Cookies.set(COOKIE_FIRST, 1);

      setTimeout(function() {
        $popupWrap.addClass("pop-up--transitioning");

        document.body.classList.add("has-pop-up");

        setTimeout(function() {
          $popupWrap.addClass("pop-up--in");

          trap = focusTrap($popup.get(0), {
            clickOutsideDeactivates: () => true,
            onDeactive: () => {
              $popupWrap.removeClass("pop-up--in");
              document.body.classList.remove("has-pop-up");
            }
          });

          trap.activate();
        }, 1000);
      }, 3000);
    }

    if (Cookies.get(COOKIE_CLOSE) != 1 && Cookies.get(COOKIE_SECOND) == 1) {
      setTimeout(function() {
        $popupWrap.addClass("pop-up--transitioning");

        document.body.classList.add("has-pop-up");

        setTimeout(function() {
          $popupWrap.addClass("pop-up--in");

          trap = focusTrap($popup.get(0), {
            clickOutsideDeactivates: () => true,
            onDeactive: () => {
              $popupWrap.removeClass("pop-up--in");
              document.body.classList.remove("has-pop-up");

              Cookies.set(COOKIE_CLOSE, 1, {
                expires: 1
              });
            }
          });

          trap.activate();
        }, 1000);
      }, 3000);
    }

    //checks for closer, via the toggle
    $toggle.on("click", function() {
      $popupWrap.removeClass("pop-up--in");
      document.body.classList.remove("has-pop-up");

      trap.deactivate();

      Cookies.set(COOKIE_CLOSE, 1, {
        expires: 1
      });
    });

    //checks if user has escaped out of the popup
    $(document).on("keydown", function(e) {
      if (e.which == 27) {
        $popup.removeClass("pop-up--in");

        document.body.classList.remove("has-pop-up");

        trap.deactivate();

        setTimeout(() => $popup.detach(), 1000);
        Cookies.set(COOKIE_CLOSE, 1, {
          expires: 1
        });
      }
    });

    $(document).on("gform_confirmation_loaded", function(event, formId) {
      if (formId == popupFormID) {
        Cookies.set(COOKIE_SUBMISSION, 1, {
          expires: 7300 // 20 years
        });
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./scripts/lib/pop-up.js